import { render, staticRenderFns } from "./PFLoanDisbursementReport.vue?vue&type=template&id=05940b46"
import script from "./PFLoanDisbursementReport.vue?vue&type=script&lang=js"
export * from "./PFLoanDisbursementReport.vue?vue&type=script&lang=js"
import style0 from "./PFLoanDisbursementReport.vue?vue&type=style&index=0&id=05940b46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports